"use client";
import { useState, useEffect } from "react";
import Image from "next/image";
import { FaArrowRight } from "react-icons/fa"; // Importing arrow icon from react-icons

const Intro = () => {
  return (
    <div>
      <section className="py-10 md:py-16">
        <div className="max-w-screen-xl mx-5 lg:mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-6 lg:gap-12 items-start justify-between">
            {/* Text Section */}
            <div className="order-2 lg:order-1">
              <h2 className="font-medium text-color-blue-600 my-3">
                Visa Services
              </h2>
              <ul className="space-y-3 mb-4 text-lg font-sans">
                <li className="flex items-start">
                  <FaArrowRight className="text-red-600 mr-5 mt-2 w-7 h-7" />
                  Prepares the passport and visa application cases with highest
                  accuracy.
                </li>
                <li className="flex items-start">
                  <FaArrowRight className="text-red-600 mr-5 mt-2 w-7 h-7" />
                  Assists with appointments, follow ups and monitoring status of
                  the application.
                </li>
                <li className="flex items-start">
                  <FaArrowRight className="text-red-600 mr-5 mt-2 w-7 h-7" />
                  Also provides meet and assist service at the Embassy or VFS
                  and comfort the applicants.
                </li>
                <li className="flex items-start">
                  <FaArrowRight className="text-red-600 mr-5 mt-2 " />
                  Provides Express Arrangements for 20+ countries
                </li>
                <li className="flex items-start">
                  <FaArrowRight className="text-red-600 mr-5 mt-2 w-8 h-8" />
                  Assists with Embassy processes like attestation of documents,
                  getting documents apostilled or translation.
                </li>
                <li className="flex items-start">
                  <FaArrowRight className="text-red-600 mr-5 mt-2" />
                  Extends its visa services to different nationalities.
                </li>
              </ul>
            </div>

            {/* Image Section */}
            <div className="relative w-full h-full order-1 lg:order-2">
              <Image
                src="/images/Visa-Services.jpg"
                alt="Visa Services"
                fill
                className="object-cover"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Intro;
